<template>
  <div class="flex flex-col">
    <TableProducts />
  </div>
</template>

<script>
import TableProducts from '@/components/Table/Products'

export default {
  components: {
    TableProducts,
  },
  theme() {
    return {
      title: 'Products',
      buttons: [
        {
          to: '/products/add',
          label: '+ Ajouter produit',
        },
      ],
    }
  },
}
</script>

<style></style>
